import { MessageType } from '@common/model/dialog/message/messageType';
import React from 'react';
import { DialogMessageRenderer, DialogTextMessage } from '@cp/entities/dialog';

export const FallbackMessage: DialogMessageRenderer = (props) => {
  return (
    <DialogTextMessage {...props} message={Object.assign({}, props.message, { type: MessageType.Text, payload: 'Сообщение повреждено' })} />
  );
};
